import { IPageTab } from '../../../common/interfaces/tabs.interface';

export const SERVICE_TABS: IPageTab[] = [
  { id: 0, name: 'Lista servicii', href: '' },
  { id: 1, name: 'Feedback servicii', href: 'feedback' },
];
